/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Trades_DescriptionInputs */



/**
* | output |
* | --- |
* | "Swap cards with people in your groups: matches from your wishlists and tradelists, requests, and swaps to confirm." |
*
* @param {Nav_Locked_Trades_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_trades_description = /** @type {((inputs?: Nav_Locked_Trades_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Trades_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tausche Karten mit Leuten aus deinen Gruppen: Treffer aus deinen Wunsch- und Tauschlisten, Anfragen und offene Tausche.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échangez des cartes avec les membres de vos groupes : correspondances de vos listes de souhaits et d'échange, demandes et échanges à confirmer.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("与小组成员交换卡牌：来自心愿单和交换清单的匹配、交换请求，以及待确认的交换。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("和社團成員交換卡牌：依願望清單與交換清單配對、提出邀請，以及待確認的交換。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("그룹 멤버와 카드를 교환하세요. 위시리스트와 교환 목록 기반 매칭, 요청, 확정 대기 교환을 한곳에서 관리합니다.")
	return /** @type {LocalizedString} */ ("Swap cards with people in your groups: matches from your wishlists and tradelists, requests, and swaps to confirm.")
});